export default "__VITE_ASSET__D5jv4fEP__"